const isObjectsDroppableToResource = (toResource, dragOverObject) => {
  if (dragOverObject.objectParentId === toResource) {
    return false;
  }
  if (dragOverObject.objectId === toResource || dragOverObject.objectIds?.includes(toResource)) {
    return false;
  }
  return true;
};

export { isObjectsDroppableToResource };
//# sourceMappingURL=draggable.js.map
